module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/user-card-afb815c3e2b68f67435c271473754397.svg";